function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
import videojs from 'video.js'; //// CONTROLLER ////

(function () {
  'use strict';

  angular.module('comcast.directives').directive('ctsSpotPlayer', ['$window', function ($window) {
    return {
      restrict: 'E',
      template: '<video id="player" class="video-js vjs-default-skin vjs-big-play-centered cts-spot-player" preload="auto" controls data-setup="{}"><p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that<a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p></video>',
      scope: {
        source: '@',
        type: '@',
        width: '@playerWidth'
      },
      link: function link(scope, element, attr, ngModelCtrl) {
        // Retrieve the actual player element associated with this directive
        var playerEle = element.find('video')[0];
        angular.element(playerEle).addClass('cts-spot-player');
        var videoPlayer; // Initialize the VideoJS player

        videoPlayer = videojs(playerEle, {
          techOrder: ['html5']
        });
        var ModalDialog = videojs.getComponent('ModalDialog');
        var ccOverlayModal = new ModalDialog(videoPlayer, {
          content: '',
          // Use a DOM element as content
          temporary: false,
          // Don't delete this DOM element when it closes
          pauseOnOpen: false // Don't stop the video when the overlay is added

        });
        ccOverlayModal.addClass('cc-safe-overlay');
        videoPlayer.addChild(ccOverlayModal);
        videoPlayer.on('showCCSafeOverlay', function () {
          ccOverlayModal.open();
        });

        var ToggleCcSafeButton =
        /*#__PURE__*/
        function (_videojs$getComponent) {
          _inherits(ToggleCcSafeButton, _videojs$getComponent);

          function ToggleCcSafeButton(player) {
            var _this;

            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, ToggleCcSafeButton);

            // Always call super, to get any setup stuff from the extended class
            _this = _possibleConstructorReturn(this, _getPrototypeOf(ToggleCcSafeButton).call(this, player, options)); // We'll just use the videojs default CC icon for now

            _this.addClass('vjs-icon-captions'); // Keep a reference to the player which contains this button


            _this.parentPlayer = player;
            return _this;
          }
          /**
           * Toggle the CC Safe Overlay on and off
           */


          _createClass(ToggleCcSafeButton, [{
            key: "handleClick",
            value: function handleClick(_e) {
              // On the player, trigger the event to show the CC Safe overlay
              this.parentPlayer.trigger('showCCSafeOverlay');
            }
          }]);

          return ToggleCcSafeButton;
        }(videojs.getComponent('Button')); // Create an instance of our customo button and add it to the player's control bar


        var ccSafeToggle = new ToggleCcSafeButton(videoPlayer);
        videoPlayer.controlBar.addChild(ccSafeToggle); // When the player is ready, manage DOM stuff

        videoPlayer.ready(function () {
          var player = this; // Watch for source changes, so if something loads after the page it will show it

          scope.$watch('source', function (newSrc) {
            if (newSrc) {
              player.src({
                type: scope.type,
                src: newSrc
              });
            }
          }); // Set player sizing to be in 16:9 ratio

          var playerHeight = scope.width !== undefined ? scope.width * (900 / 1600) : 400 * (900 / 1600);
          var playerWidth = scope.width !== undefined ? scope.width : 400; // Sizing the player (always 16:9)

          player.height(playerHeight);
          player.width(playerWidth);
          scope.$on('$destroy', function () {
            player.dispose();
          });
        });
      }
    };
  }]);
})();